var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.303823 13.2512L6.75217 1.31197C7.69694 -0.437311 10.2067 -0.437325 11.1515 1.31194L17.6 13.2512C18.4996 14.9169 17.2934 16.9393 15.4003 16.9393H2.50349C0.610409 16.9393 -0.595798 14.9169 0.303823 13.2512ZM9.01738 4.5C8.65416 4.5 8.35972 4.79445 8.35972 5.15766V9.41053C8.35972 9.77375 8.65416 10.0682 9.01738 10.0682C9.3806 10.0682 9.67505 9.77375 9.67505 9.41053V5.15766C9.67505 4.79445 9.3806 4.5 9.01738 4.5ZM9.01222 13.6221C9.59337 13.6221 10.0645 13.1499 10.0645 12.5675C10.0645 11.9851 9.59337 11.5129 9.01222 11.5129C8.43108 11.5129 7.95996 11.9851 7.95996 12.5675C7.95996 13.1499 8.43108 13.6221 9.01222 13.6221Z",
    fill: "#B3261E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIconFilled);
export default __webpack_public_path__ + "static/media/alert_icon_filled.bab5fa4395eeef7294f3cb9054f6d93a.svg";
export { ForwardRef as ReactComponent };